<div class="page-head">
  <div>
    <h1>Terminals</h1>
    <div class="sub">
      {{ rangeLabel }}<span class="loading-inline" *ngIf="isLoading"> · Loading…</span>
    </div>
  </div>
  <div class="head-actions">
    <button type="button" class="act-ghost" (click)="load()" [disabled]="isLoading">Refresh</button>
  </div>
</div>

<div class="page-body">
  <p class="section-hint">
    Every terminal on the platform, the ones that have stopped reporting first. A terminal counts as
    offline once it has been silent for {{ offlineAfterMinutes }} minutes. <strong>Offline mode</strong>
    means an operator deliberately prepared that terminal to trade without a connection — expect it to
    go quiet. <strong>Disabled</strong> is an admin switch and says nothing about whether the terminal
    is reachable.
  </p>

  <div class="note note-err" *ngIf="error">{{ error }}</div>

  <div class="chip-row">
    @for (chip of chips; track chip.key) {
      <button type="button" class="stat-chip" [class.active]="status === chip.key" [ngClass]="chip.tone"
        (click)="setStatus(chip.key)">
        <span class="chip-count">{{ chipCount(chip) }}</span>
        <span class="chip-label">{{ chip.label }}</span>
      </button>
    }
  </div>

  <div class="toolbar">
    <input class="inp search" type="search" placeholder="Search terminal or business…"
      [ngModel]="searchTerm" (ngModelChange)="onSearch($event)" aria-label="Search terminals" />
  </div>

  <div class="tbl-wrap">
    <table class="tbl">
      <thead>
        <tr>
          <th>Terminal</th>
          <th>Business</th>
          <th>Status</th>
          <th>Last seen</th>
          <th>Flags</th>
          <th>Last IP</th>
        </tr>
      </thead>
      <tbody>
        @for (t of terminals; track t.terminalId) {
          <tr>
            <td>
              <span class="row-title">{{ terminalLabel(t) }}</span>
              <div class="row-sub">#{{ t.terminalNo }}</div>
            </td>
            <td>
              @if (t.businessId) {
                <button type="button" class="act-link" (click)="openBusiness(t)">
                  {{ t.businessName || t.businessId }}
                </button>
              } @else {
                <span class="muted">—</span>
              }
            </td>
            <td><span [class]="statusClass(t)">{{ statusLabel(t) }}</span></td>
            <td>
              @if (t.lastSeenUtc) {
                <span class="row-title">{{ lastSeenAge(t) }}</span>
                <div class="row-sub">{{ t.lastSeenUtc | date: 'short' }}</div>
              } @else {
                <span class="muted">Never</span>
              }
            </td>
            <td>
              <div class="flags">
                @if (t.offlineMode) {
                  <span class="pill pill-sm pill-amber"
                    [title]="'Switched on ' + (t.offlineModeChangedUtc | date: 'short')">Offline mode</span>
                }
                @if (!t.isActive) {
                  <span class="pill pill-sm pill-grey">Disabled</span>
                }
                @if (!t.offlineMode && t.isActive) {
                  <span class="muted">—</span>
                }
              </div>
            </td>
            <td>
              @if (t.lastIpAddress) {
                <code class="mono code">{{ t.lastIpAddress }}</code>
              } @else {
                <span class="muted">—</span>
              }
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="6" class="empty">
              @if (isLoading) { Loading terminals… } @else { No terminals matched this view. }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="pagination" *ngIf="totalPages > 1">
    <span class="muted">{{ rangeLabel }}</span>
    <div class="pager">
      <button type="button" class="act-ghost act-sm" [disabled]="page <= 1" (click)="setPage(1)" aria-label="First page">« First</button>
      <button type="button" class="act-ghost act-sm" [disabled]="page <= 1" (click)="setPage(page - 1)" aria-label="Previous page">‹ Prev</button>
      <span class="page-indicator">Page {{ page }} of {{ totalPages }}</span>
      <button type="button" class="act-ghost act-sm" [disabled]="page >= totalPages" (click)="setPage(page + 1)" aria-label="Next page">Next ›</button>
      <button type="button" class="act-ghost act-sm" [disabled]="page >= totalPages" (click)="setPage(totalPages)" aria-label="Last page">Last »</button>
    </div>
  </div>
</div>
